<template v-if="getOptions(item).length">
    <div class="row" style="margin-top: 10px;">
        <div class="col-12">
            <div class="form-group" style="width: 100%;">
                <label :for="item.key">{{ item.label }}</label>
                <select :id="item.key" :name="item.key" :placeholder="item.label" v-model="itemValue" class="form-control">
                    <option v-for="option in getOptions(item)" :value="option.trim()">{{ option.trim() }}</option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../../../../EventBus'

    export default {
        props: [
            'item',
            'restaurant'
        ],

        data () {
            return {
                itemValue: this.getOptions(this.item)[0].trim()
            }
        },

        watch: {
            itemValue: function(newValue, oldValue) {
                EventBus.$emit('serviceTypeFormValueUpdated', {
                    key: this.item.key,
                    value: this.itemValue
                });
            }
        },

        mounted() {
            EventBus.$emit('serviceTypeFormValueUpdated', {
                key: this.item.key,
                value: this.getOptions()[0]
            });
        },

        methods: {
            getOptions(item) {
                let serviceTypeConfig = this.restaurant.service_type_config;
                if (serviceTypeConfig.service_type_select) {
                    return serviceTypeConfig.service_type_select.split(',');
                } else {
                    if (item && item.options) {
                        return item.options.split(',');
                    } else {
                        return [];
                    }
                }
            }
        }
    }
</script>